import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PortalSidebarMenuModel } from './portal-sidebar-menu.model';
import { PortalSidebarMenuService } from './portal-sidebar-menu.service';

@Component({
  selector: 'app-sidebar-list',
  templateUrl: './sidebar-list.component.html',
  styleUrls: ['./sidebar-list.component.scss'],
  standalone: false
})
export class SidebarListComponent implements OnInit {
  @Output() sidebarClose = new EventEmitter<void>();
  @Input() userName: string;
  menus: PortalSidebarMenuModel[] = [];

  constructor(private portalSidebarMenuService: PortalSidebarMenuService) {}
  ngOnInit(): void {
    this.portalSidebarMenuService.getSidebarMenus().then((menus) => {
      this.menus = menus;
    });
  }

  onClose() {
    this.sidebarClose.emit();
  }
}
